module.exports = __webpack_public_path__ + "2170b2e8fa6072a4ea0e1893f352af1b.jpg";